import {useEffect, useRef} from 'react';
import {useAppSelector} from '@/hooks';
import type {PosterLoadObject} from '@PosterWhiteboard/poster/poster.types';

export const useSavePosterBeforeDownloadIfImageUploading = (isOpenedInEditor = true, posterObject: PosterLoadObject, panelId: string, isOpenedInModal: boolean): void => {
  const areImagesUploading = useAppSelector((state) => {
    return !!state.posterEditor.posterObject?.uploadingImages.length;
  });
  const isDownloadPanelOpened = useAppSelector((state) => {
    return state.downloadDialog.panelOpenState;
  });
  const isModalHidden = useAppSelector((state) => {
    return state.panels.panelHashmap[panelId]?.isHidden;
  });
  const isModalOrPanelOpened = (isOpenedInModal && !isModalHidden) || isDownloadPanelOpened;
  const wereImagesUploadingRef = useRef(areImagesUploading);

  useEffect(() => {
    if (!isModalOrPanelOpened) {
      wereImagesUploadingRef.current = false;
      return;
    }
  }, [isModalOrPanelOpened]);

  useEffect(() => {
    const wereImagesUploading = wereImagesUploadingRef.current;
    wereImagesUploadingRef.current = areImagesUploading;

    if (wereImagesUploading && !areImagesUploading && isOpenedInEditor && isModalOrPanelOpened) {
      void window.posterEditor?.whiteboard?.savePoster.save();
    }
  }, [areImagesUploading]);

  return;
};
